<template>
  <div class="page quality-page">
    <h1>{{ page.heading }}</h1>
    <p class="page-intro">
      从产区的种植管理，到工厂里的加工环节，再到产地直播，这些是我们愿意公开讲清楚的部分。
    </p>
    <ContactFriend placement="hero" />
    <section class="quality-card">
      <h2>原料来自产区</h2>
      <p>石斛原料来自云南龙陵的种植基地，三七来自云南文山，灵芝原料来自高黎贡山一带。</p>
    </section>
    <section class="quality-card">
      <h2>产品形态</h2>
      <p>
        目前公开参数的是即食原浆：紫皮石斛原浆、铁皮石斛原浆与天麻原浆，均有盒装与量贩装规格，
        开袋即饮。各款的净含量、配料与食用方法见<a href="/products.html">匠心产品</a>的对照表。
      </p>
    </section>
    <section class="quality-card">
      <h2>产地溯源直播</h2>
      <p>品牌会通过溯源直播展示种植基地与加工现场，让原料来源可以被直接看到。</p>
    </section>
    <section class="quality-card">
      <h2>资质与检测资料</h2>
      <p>
        包装标签上可公开的配料、保质期、贮存条件与成分标示值，已经直接写在各产品页；
        与批次相关的执行标准、检测报告等材料不在网页上公布，可
        <a href="/contact.html">联系我们</a>查询，或拨打服务热线 400-831-7518。
      </p>
    </section>
  </div>
</template>

<script>
import ContactFriend from '@/components/ContactFriend.vue'
import { resolvePage } from '@/content/siteContent.mjs'

const page = resolvePage('/quality.html')

export default {
  name: 'QualityPage',
  components: {
    ContactFriend
  },
  data() {
    return { page }
  }
}
</script>

<style scoped>
.page {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px 16px 48px;
  text-align: left;
}

h1 {
  color: #4b0082;
  font-size: 1.5em;
  margin: 0 0 8px;
}

h2 {
  color: #4b0082;
  font-size: 1.1em;
  margin: 0 0 6px;
}

.page-intro,
p {
  color: #333;
  line-height: 1.8;
  margin: 0;
}

.quality-card {
  background: #fff;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(75, 0, 130, 0.06);
  margin-top: 14px;
}

a {
  color: #6a1bb0;
}
</style>
